import React from 'react';
import { Component } from 'react';
import { PlusIcon } from '../../ui/icons';
import colors from '../../css/colors';
import styled from '@emotion/styled';

const AddPropertyWrap = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-weight: 700;
  margin-top: 32px;
  margin-bottom: 32px;
`;
const PlusButton = styled.div`
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #8e8e93;
  display: flex;
  height: 30px;
  justify-content: center;
  margin-right: 10px;
  width: 30px;
  :hover {
    background-color: #f5f5f5;
  }
`;
export default class AddAdditionalData extends Component {
  render() {
    const { dataName, onClick } = this.props;
    return (
      <AddPropertyWrap>
        <PlusButton onClick={onClick}>
          <PlusIcon style={{height:16, width:16}}/>
        </PlusButton>
        <span style={{fontSize:16}}>{dataName}</span>
      </AddPropertyWrap>
    );
  }
}
